import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["headingText", "bgColor", "color", "bodyText", "isComingSoon", "cta", "mediaSide"];
import { CUICardBody } from 'connect-dot-com-ui-components/Components/CUICard/CUICard';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import HomepageComingSoonTag from './HomepageComingSoonTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HomepageCardDescriptionSection = _ref => {
  let {
      headingText,
      bgColor,
      color = '#FFF',
      bodyText,
      isComingSoon,
      cta,
      mediaSide
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIStack, Object.assign({
    width: {
      base: '100%',
      md: '50%'
    }
  }, rest, {
    bgColor: bgColor,
    children: /*#__PURE__*/_jsx(CUICardBody, {
      paddingY: 12,
      paddingLeft: mediaSide === 'left' ? 6 : {
        base: 6,
        lg: 0
      },
      paddingRight: mediaSide === 'right' ? 6 : {
        base: 6,
        lg: 0
      },
      children: /*#__PURE__*/_jsxs(CUIFlex, {
        direction: "column",
        height: "100%",
        align: "start",
        children: [isComingSoon && /*#__PURE__*/_jsx(HomepageComingSoonTag, {
          marginBottom: "2"
        }), /*#__PURE__*/_jsx(CUIHeading, {
          as: "h2",
          variant: "taglineTwo",
          color: color,
          children: headingText
        }), /*#__PURE__*/_jsx(CUIText, {
          py: "5",
          fontSize: "lg",
          color: color,
          children: bodyText
        }), cta]
      })
    })
  }));
};
export default HomepageCardDescriptionSection;